<template>
  <div class="content">
    <h1>
      <span>Version v{{ version }}</span>
    </h1>
  </div>
</template>

<script>
  import { version } from '../../../package.json'

  export default {
    data () {
      return {
        version,
      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utilities/Version.vue